

function objectToQuery(o) {
  const arr = [];
  for (let i in o) {
    arr.push(encodeURIComponent(i) + '=' + encodeURIComponent(o[i]));
  }
  return arr.join('&');
}


const jsonp = ({url, data,callbackFunctionName}) => {
  const container = document.getElementsByTagName('head')[0];
  const fnName = `jsonp_${new Date().getTime()}`;
  const script = document.createElement('script');
  script.src = `${url}?${objectToQuery(data)}&${callbackFunctionName?callbackFunctionName:'callback'}=${fnName}`;
  script.type = 'text/javascript';
  container.appendChild(script);

  return new Promise((resolve, reject) => {
    window[fnName] = function (res) {
      container.removeChild(script);
      delete window[fnName];
      resolve(res);
    }

    script.onerror = function () { // 异常处理
      container.removeChild(script);
      delete window[fnName];
      reject('something error hanppend!');
    }
  });

}

export default jsonp;
